/**
 * Helpers
 */

const percentageCalc = ({ partialValue, totalValue, minMax = false }) => {

    const value = (100 * partialValue) / totalValue;

    if (minMax) {
        if (value > 100) {
            return 100;
        }
        else if (value < 0) {
            return 0
        }
    }
    return value;
}

class CartProgressBar {

    constructor(elem) {

        this.dom = {
            main: elem,
            label: {
                container: elem.querySelector('.cart-progress__label'),
                first: elem.querySelector('.cart-progress__label--1'),
                last: elem.querySelector('.cart-progress__label--2')
            },
            bottomLabel: document.querySelector('[data-shipping-price]'),
            bar: {
                inner: elem.querySelector('.cart-progress__inner-bar')
            }
        }
        this.text = {
            shippingPrice: theme.strings.shippingPrice,
            free: theme.strings.free
        }
        this.settings = {
            threshold: Number(elem.dataset.threshold),
            aboveThreshold: Number(elem.dataset.threshold) < Number(elem.dataset.cartTotalPrice),
            currentPercentage: 0,
            currentPrice: Number(elem.dataset.cartTotalPrice)
        }

        this.initListeners();
        
    }

    updateProgress({ price, animate = true }) {

        const percentage = percentageCalc({ partialValue: price, totalValue: this.settings.threshold, minMax: true })


        this.updateLabel({ percentage, price, animate });
        this.updateBar({ percentage });
        // this.updateBottomLabel({ percentage });

        this.settings.currentPercentage = percentage;
    }

    removeAnimateClasses() {
        this.dom.label.container.classList.remove('animate');
        this.dom.label.container.classList.remove('animate--up');
        this.dom.label.container.classList.remove('animate--down');
    }


    updateLabel({ percentage, price, animate }) {

        const newLabelText = this.getLabelText({ percentage, price });


        if (this.settings.threshold > price) {
            this.settings.aboveThreshold = false;
        }


        if (this.settings.threshold < price && this.settings.aboveThreshold === true ) {
            animate = false
            this.settings.aboveThreshold = true;
        }
        else if (this.settings.threshold < price){
            this.settings.aboveThreshold = true;
        }


        if (!animate) {
            this.dom.label.first.innerHTML = newLabelText;
            this.updateLabelHeight({ elem: this.dom.label.first })
        }
        else {
            this.removeAnimateClasses();

            this.dom.label.last.innerHTML = newLabelText;
            this.dom.label.first.addEventListener('transitionend', () => {

                this.dom.label.first.innerHTML = this.dom.label.last.innerHTML;
                this.removeAnimateClasses();

                this.dom.label.first.removeEventListener('transitionend', () => { })

            });

            if (this.settings.currentPrice > price) {
                this.dom.label.container.classList.add('animate--down');
            }
            else {
                this.dom.label.container.classList.add('animate--up');
            }

            setTimeout(() => {
                this.dom.label.container.classList.add('animate');

                this.updateLabelHeight({ elem: this.dom.label.last })
                this.settings.currentPrice = price;
            }, 50);
        }
    }


    getLabelText({ percentage, price }) {
        if (percentage == 100) {
            document.dispatchEvent(new CustomEvent('cart:free-shipping'))
            return theme.strings.freeShipping;
        }
        else {
            document.dispatchEvent(new CustomEvent('cart:default-shipping'))
            let remainingText = theme.strings.freeShippingRemaining;
            const remainingmoney = this.settings.threshold - price;
            const remainingmoneyFormatted = theme.Currency.formatMoney(remainingmoney, theme.settings.moneyFormat);

            return remainingText.replace('[remaining]', remainingmoneyFormatted);
        }
    }

    updateBar({ percentage }) {
        this.dom.bar.inner.style.setProperty('--progress', `${ percentage }%`);
        this.dom.bar.inner.style.setProperty('--progress_opacity', `${ percentage / 100 }`);
    }

    updateLabelHeight({ elem }) {
        if (elem.offsetHeight === 0) return
        this.dom.label.container.style.height = `${ elem.offsetHeight }px`;
    }

    //cart:quantity
    initListeners() {
        document.addEventListener('cart:updated', (data) => {
            const totalPrice = data?.detail?.cart?.original_total_price ? Number(data.detail.cart.original_total_price) : 0;
            this.updateProgress({ price: totalPrice });
        })

        document.addEventListener('ajaxProduct:added', () => {
            theme.cart.getCart().then((data) => {
                if (!data?.original_total_price) return
                this.updateProgress({ price: data.original_total_price, animate: true });
            });
        })

        document.addEventListener('cart:is-open', () => {
            //Timeout so the elem is visible and has a client height
            setTimeout(() => {
                this.updateLabelHeight({ elem: this.dom.label.first })
            }, 0);
        })

        /**
         * fixes label height on resize
         */
        let initFunc;
        window.onresize = () => {
            clearTimeout(initFunc);
            initFunc = setTimeout(() => {
                this.updateLabelHeight({ elem: this.dom.label.first })
            }, 200);
        };
    }
}

class FreeShippingText {
    constructor(main) {

        this.dom = {
            main: main
        }

        this.strings = {
            default: main.dataset?.textDefault ? main.dataset.textDefault : '',
            free: main.dataset?.textFree ? main.dataset.textFree : theme.strings.freeShipping
        }

        this.EventListeners();
    }

    EventListeners() {

        document.addEventListener('cart:free-shipping', () => {
            this.dom.main.innerHTML = this.strings.free
        })

        document.addEventListener('cart:default-shipping', () => {
            this.dom.main.innerHTML = this.strings.default
        })
    }
}



const addFallbackCssClassToOldBundle = (bundleItemsWithoutMaster) => {
    bundleItemsWithoutMaster.forEach(bundleItem => {
        bundleItem.classList.add('fallback');
    });
}

const runBundleMaterFallbackCheck = () => {
    const cartBundleIdArr = [...document.querySelectorAll('[data-bundle-id]:not(button):not([data-bundle-master])')].map(x => x.dataset.bundleId);
    const uniqCartBundleIdArr = [...new Set(cartBundleIdArr)];

    


    uniqCartBundleIdArr.forEach(uniqCartBundleId => {
        const bundleItemsWithMaster = document.querySelectorAll(`[data-bundle-id="${uniqCartBundleId}"][data-bundle-master]:not(button)`)
        
        if (bundleItemsWithMaster.length <= 0) {
            console.log('no master');
            const bundleItemsWithoutMaster = document.querySelectorAll(`[data-bundle-id="${uniqCartBundleId}"]:not(button)`);
            addFallbackCssClassToOldBundle(bundleItemsWithoutMaster)
        }

    });

    console.log(`uniqCartBundleIdArr: `, uniqCartBundleIdArr);
}


class CustomCartDrawer {

    constructor(main) {

        this.dom = {
            main: main,
            labels: {
                productCount: main.querySelector('[data-product-count]')
            }
        }

        this.Init();
    }


    Init() {
        this.EventListeners();
    }

    EventListeners() {

        this.handleUpdateClicks = this.handleUpdateClicks.bind(this);
        this.dom.main.addEventListener('click', this.handleUpdateClicks);

        document.addEventListener('cart:updated', (data) => {
            const productCount = data?.detail?.cart?.item_count ? Number(data.detail.cart.item_count) : 0;
            this.UpdateProductCount({ productCount });
        })
        
        document.addEventListener('ajaxProduct:added', () => {
            theme.cart.getCart().then((data) => {
                const productCount = data?.item_count ? Number(data.item_count) : 0;
                this.UpdateProductCount({ productCount });
            });
        })

    }




    handleUpdateClicks(e) {
        var target = e.target;

        if (target.hasAttribute('data-change')) {
            e.preventDefault();

            var url = new URL(target.href);
            url.pathname = `${ url.pathname }.js`;

            fetch(url.href)
                .then(response => response.json())
                .then((cart) => {
                    document.dispatchEvent(new CustomEvent('cart:build'), () => {                        
                    })

                    document.dispatchEvent(new CustomEvent('cart:updated', {
                        detail: {
                            cart: cart
                        }
                    }));
                })
        }
    }


    UpdateProductCount({ productCount }) {
        this.dom.labels.productCount.innerText = theme.strings.itemCount.replace('[itemCount]', productCount)
    }
}




const progressBar = document.getElementById('cartProgressBar');
const cartDrawer = document.getElementById('CartDrawer');
const freeShippingTexts = document.querySelectorAll('.js-shipping-text');

if (cartDrawer) {
    void new CustomCartDrawer(cartDrawer);
}
if (progressBar) {
    void new CartProgressBar(progressBar);
}

freeShippingTexts.forEach(freeShippingText => {
    void new FreeShippingText(freeShippingText);
});



/**
 * 
 * Fallback
 */
window.addEventListener('load', function() {
runBundleMaterFallbackCheck();
});

document.addEventListener('cart:updated', () => {
    setTimeout(() => {
        console.log('buildeds');
        runBundleMaterFallbackCheck();
    }, 1000);
})

document.addEventListener('ajaxProduct:added', () => {
    setTimeout(() => {
        console.log('buildeds');
        runBundleMaterFallbackCheck();
    }, 1000);
})
